export default function PageTitle({
  title,
  children = null,
  bottomAlignTitle = false,
  alignChildren = "right",
}) {
  return (
    <div
      className={`flex flex-row mt-6 mb-2 relative ${
        bottomAlignTitle ? "items-end" : "items-center"
      }`}
    >
      <div className="flex items-center space-x-4">
        <h1
          className="text-left text-primary"
          data-testid={`page-title-${title}`}
        >
          {title}
        </h1>
        {alignChildren === "left" && children}
      </div>
      <div className="flex items-center space-x-2 ml-auto flex-1 justify-end">
        {alignChildren === "right" && children}
      </div>
    </div>
  );
}
